module.exports = __webpack_public_path__ + "static/media/3DPPA13.90f6a996.jpg";